<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <Select
    allow-clear
    :filter-option="filterOption"
    :max-tag-count="1"
    :mode="isMultiple ? 'multiple' : undefined"
    :options="options"
    placeholder="请选择"
    show-search
    style="width: 194px"
  />
</template>

<script setup lang="ts">
import { onMounted, ref, defineProps } from 'vue'
import { type SelectOptions } from './types'
import { Select } from 'ant-design-vue'
import { getUserList } from './service'

const props = defineProps({
  isMultiple: {
    type: Boolean,
    default: true,
  },
  useLoginname: {
    type: Boolean,
    default: true,
  },
})

const filterOption = (input: string, option: SelectOptions) => {
  return option.label.toLowerCase().includes(input.toLowerCase())
}

const options = ref<SelectOptions[]>()
const getOptions = () => {
  getUserList()
    .then(res => {
      const list = res.records || []

      options.value = list.map(item => {
        return {
          label: item.name,
          value: props.useLoginname ? item.loginname : item.name,
        }
      })
    })
}

onMounted(() => {
  getOptions()
})

</script>

<style scoped lang="less">

</style>
